// Owner: doc-signing (owner feedback F5). Keyboard commands of the prepare editor (scope
// `signatures.prepare`, a layer scope): the editor verbs of the interaction kit on the selected field —
// ⌘Z / ⌘⇧Z, ⌘D, Delete, Esc, arrows (⇧ = 10 points). Copy and paste are the kit's clipboard events.
// Discovered by glob; keep this file tiny (the editor itself loads on first open).
import { defineScope, editCommands, type EditActions } from '@dataroom/interaction';
import { defineAppCommands } from '../../extensions/commands';
import { t } from '../../lib/i18n';

export type PrepareContext = EditActions;

export const prepareScope = defineScope<PrepareContext>({
  id: 'signatures.prepare',
  kind: 'editor',
  title: () => t('inbox.signatureScope'),
});

const KEYWORDS = [
  'signature',
  'signatures',
  'sign',
  'esign',
  'docusign',
  'unterschrift',
  'unterschriften',
  'signatur',
];

export default defineAppCommands({
  id: 'signatures.prepare',
  loadTitles: () => import('../../messages-ready/inbox-unified'),
  scopes: [prepareScope],
  commands: editCommands(prepareScope, ['undo', 'redo', 'duplicate', 'delete', 'escape', 'nudge']),
  // ⌘K: the list of signature requests (the Inbox links to it as well).
  providers: [
    {
      id: 'signatures.go',
      items: (query) => {
        const q = query.trim().toLowerCase();
        if (q && !KEYWORDS.some((k) => k.startsWith(q) || q.startsWith(k))) return [];
        return [
          {
            id: 'signatures.list',
            title: t('inbox.signaturesLink'),
            icon: 'pencil',
            group: t('inbox.title'),
            keywords: KEYWORDS,
            href: '/signatures',
          },
        ];
      },
    },
  ],
});
